import ajax from './../ajax';

export const signUpCampusAmbassador = ({
  name,
  email,
  phone,
  semester,
  college,
  stream,
  voucher
}) => {
  return ajax('/campus_ambassadors', {
    method: 'POST',
    body: {
      campus_ambassador: {
        name,
        email,
        phone,
        semester,
        college,
        stream,
        voucher
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/v1/campusAmbassador.js